import React from 'react';
import Checkbox from 'shared/components/andtComponents/Checkbox';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import Tooltip from 'shared/components/andtComponents/Tooltip';

import styles from './FullAccessCheckbox.module.scss';

const FullAccessCheckbox = ({ isFullAccess, isDisabled, onFullAccessSelectChanged }) => {
  const getTooltipTitle = () => (
    <div>
      Check the <i>full access</i> box to provide access to any of your accounts, available now or onboarded later. Make
      sure you only give this permission to the people that need such complete access.
    </div>
  );

  const fullAccessContent = () => (
    <div className={styles.fullAccess}>
      <div>Full Access</div>
      <Tooltip title={getTooltipTitle()} placement="top">
        <span>
          <GenerateIcon iconName={ICONS.shieldKeyhole.name} className={styles.shieldKeyholeIcon} />
        </span>
      </Tooltip>
    </div>
  );

  return (
    <Checkbox
      isChecked={isFullAccess}
      isDisabled={isDisabled}
      onChange={onFullAccessSelectChanged}
      primary
      isSimple
      text={fullAccessContent()}
    />
  );
};


export default FullAccessCheckbox;
